import { Toaster } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Toaster>;

/**
 * The sonner `Toaster` outlet with rich colors preset. Mount once (usually
 * in the root layout) so `toast` and `useToast` have somewhere to render.
 *
 * @category overlays-modals
 */
export const EpicToaster = ({ theme, ...props }: ToasterProps) => (
  <Toaster theme={theme} richColors {...props} />
);
